import { AuthService } from '../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { switchMap, take } from 'rxjs/operators';
import { Contribution } from '../track/contribution';
import { Settings } from '../settings/settings';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Website } from '../website-builder/wedding';
import { map } from 'rxjs/operators';

@Injectable()
export class WebsiteResolve implements Resolve<any> {

  constructor(
    private _websiteStateStore: WebsiteStateStore,    
    private router: Router,
    private _authService: AuthService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Website> {
    
    const pageUserMode = route.data.pageUserMode;
    let registryName = route.paramMap.get('registry') ? route.paramMap.get('registry') : route.parent.paramMap.get('registry');

    
    
    if(registryName){
      registryName = registryName.toLowerCase();
      return this._websiteStateStore.getWebsiteByName(registryName).take(1).switchMap(website => {

        if (website) {
          return Observable.of(website);
        } else {
        
          return Observable.of(null);
        }
      });
    }
    
    return this._websiteStateStore.getState()
      .take(1)
      .switchMap(state => {
        
        if (!state || !state.website || (Object.keys(state.website).length === 0 && state.website.constructor === Object)) {
          console.log('WebsiteResolve - Empty website state');
          return Observable.of(null);
        }
        return Observable.of(state.website);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/website/website.resolve.ts